var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsGlueDataBrew32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Glue-DataBrew_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Glue-DataBrew_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-Glue-DataBrew_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,16 C5,16.551 4.552,17 4,17 C3.448,17 3,16.551 3,16 C3,15.449 3.448,15 4,15 C4.552,15 5,15.449 5,16 L5,16 Z M2,16 C2,17.103 2.897,18 4,18 C5.103,18 6,17.103 6,16 C6,14.897 5.103,14 4,14 C2.897,14 2,14.897 2,16 L2,16 Z M30,3.972 L30,28.028 C30,29.115 29.115,30 28.027,30 L3.973,30 C2.885,30 2,29.115 2,28.028 L2,19 L3,19 L3,28.028 C3,28.564 3.437,29 3.973,29 L28.027,29 C28.563,29 29,28.564 29,28.028 L29,3.972 C29,3.436 28.563,3 28.027,3 L3.973,3 C3.437,3 3,3.436 3,3.972 L3,13 L2,13 L2,3.972 C2,2.885 2.885,2 3.973,2 L28.027,2 C29.115,2 30,2.885 30,3.972 L30,3.972 Z M4,24 L6.693,24 C9.547,24 12.822,22.126 14.148,19.733 L15.023,20.218 C13.512,22.944 9.931,25 6.693,25 L4,25 L4,24 Z M24.063,6.501 L26.131,6.501 L25.057,5.426 L25.764,4.719 L27.829,6.785 C28.024,6.98 28.024,7.296 27.829,7.492 L25.764,9.557 L25.057,8.85 L26.406,7.501 L24.151,7.501 C21.545,7.501 18.267,8.88 16.621,11.961 L15.738,11.49 C17.333,8.506 20.678,6.501 24.063,6.501 L24.063,6.501 Z M15.879,16.164 C15.966,20.484 19.555,24 23.88,24 L26.255,24 L25.057,22.801 L25.764,22.094 L27.829,24.16 C28.024,24.355 28.024,24.672 27.829,24.867 L25.764,26.933 L25.057,26.226 L26.282,25 L23.966,25 C19.015,25 14.977,21.045 14.879,16.184 C14.788,11.595 11.273,8 6.879,8 L4,8 L4,7 L6.879,7 C11.823,7 15.776,11.025 15.879,16.164 L15.879,16.164 Z M8,13 C7.448,13 7,12.551 7,12 C7,11.449 7.448,11 8,11 C8.552,11 9,11.449 9,12 C9,12.551 8.552,13 8,13 L8,13 Z M8,10 C6.897,10 6,10.897 6,12 C6,13.103 6.897,14 8,14 C9.103,14 10,13.103 10,12 C10,10.897 9.103,10 8,10 L8,10 Z M11.149,17.988 L10.488,19.442 L9.033,18.781 L9.694,17.327 L11.149,17.988 Z M7.709,19.277 L10.984,20.767 L12.474,17.492 L9.198,16.002 L7.709,19.277 Z M25,12 L27.016,12 L27.001,18 L24.993,18 L25,12 Z M23.992,19 L27.999,19 L28.018,11 L24.001,11 L23.992,19 Z M18.999,13 L21.016,13 L21.001,18 L18.994,18 L18.999,13 Z M17.992,19 L21.999,19 L22.018,12 L18.001,12 L17.992,19 Z",
    id: "Fill-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsGlueDataBrew32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Glue-DataBrew_32.754e206ca10a13b5863814395979022b.svg";
export { ForwardRef as ReactComponent };